import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Header from "../components/site/Header";
import Hero from "../components/site/Hero";
import PracticeAreas from "../components/site/PracticeAreas";
import Insights from "../components/site/Insights";
import Testimonials from "../components/site/Testimonials";
import Footer from "../components/site/Footer";
import BackgroundAudio from "../components/site/BackgroundAudio";
import { scrollToElement, scrollToTop } from "../components/SmoothScroll";

export default function LandingPage() {
  const location = useLocation();

  // Reveal-on-scroll (legacy CSS reveals on pages that still use them)
  useEffect(() => {
    const els = document.querySelectorAll(".reveal");
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-visible");
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: "0px 0px -40px 0px" }
    );
    els.forEach((el) => io.observe(el));
    return () => io.disconnect();
  }, []);

  // Scroll-to-hash handling (on navigate-with-hash)
  useEffect(() => {
    if (location.hash) {
      const id = location.hash.slice(1);
      const tryScroll = () => {
        const el = document.getElementById(id);
        if (el) scrollToElement(el);
      };
      setTimeout(tryScroll, 250);
    } else {
      scrollToTop(true);
    }
  }, [location.pathname, location.hash]);

  return (
    <main data-testid="landing-page" className="relative bg-cream-100 text-charcoal min-h-screen">
      <Header transparentOnTop />
      <Hero />
      <PracticeAreas />
      <Insights />
      <Testimonials />
      <Footer />
      <BackgroundAudio />
    </main>
  );
}
